export default __webpack_public_path__ + "static/media/speakerphone.cfc95469.png";